import type {
  SalesItemAddonCreateApiData,
  SalesItemAddonCreateApiResponses,
  SalesItemAddonDeleteApiData,
  SalesItemAddonDeleteApiResponses,
  SalesItemAddonListApiData,
  SalesItemAddonListApiResponses,
  SalesItemAddonPatchApiData,
  SalesItemAddonPatchApiResponses,
  SalesItemBookingCategoryForNewBookingListApiData,
  SalesItemBookingCategoryForNewBookingListApiResponses,
  SalesItemBookingCategoryListApiData,
  SalesItemBookingCategoryListApiResponses,
  SalesItemBulkPatchApiData,
  SalesItemBulkPatchApiResponses,
  SalesItemCargoDemandCreateApiData,
  SalesItemCargoDemandCreateApiResponses,
  SalesItemCargoDemandDeleteApiData,
  SalesItemCargoDemandDeleteApiResponses,
  SalesItemCargoDemandListApiData,
  SalesItemCargoDemandListApiResponses,
  SalesItemCargoDemandPatchApiData,
  SalesItemCargoDemandPatchApiResponses,
  SalesItemCargoDemandTotalListApiData,
  SalesItemCargoDemandTotalListApiResponses,
  SalesItemCatalogAdoptionListApiData,
  SalesItemCatalogAdoptionListApiResponses,
  SalesItemCatalogEntryAdoptApiData,
  SalesItemCatalogEntryAdoptApiResponses,
  SalesItemCatalogEntryCreateApiData,
  SalesItemCatalogEntryCreateApiResponses,
  SalesItemCatalogEntryDeleteApiData,
  SalesItemCatalogEntryDeleteApiResponses,
  SalesItemCatalogEntryGetApiData,
  SalesItemCatalogEntryGetApiResponses,
  SalesItemCatalogEntryListApiData,
  SalesItemCatalogEntryListApiResponses,
  SalesItemCatalogEntryPatchApiData,
  SalesItemCatalogEntryPatchApiResponses,
  SalesItemCreateApiData,
  SalesItemCreateApiResponses,
  SalesItemDeleteApiData,
  SalesItemDeleteApiResponses,
  SalesItemDeliveryCheckApiData,
  SalesItemDeliveryCheckApiResponses,
  SalesItemGetApiData,
  SalesItemGetApiResponses,
  SalesItemHourlyBonusServiceListApiData,
  SalesItemHourlyBonusServiceListApiResponses,
  SalesItemHourlyBonusServicePatchApiData,
  SalesItemHourlyBonusServicePatchApiResponses,
  SalesItemListAddonsForNewBookingApiData,
  SalesItemListAddonsForNewBookingApiResponses,
  SalesItemListApiData,
  SalesItemListApiResponses,
  SalesItemListInitialAvailableForBookingApiData,
  SalesItemListInitialAvailableForBookingApiResponses,
  SalesItemMinimalListApiData,
  SalesItemMinimalListApiResponses,
  SalesItemOfferBatchPatchApiData,
  SalesItemOfferBatchPatchApiResponses,
  SalesItemOfferGetApiData,
  SalesItemOfferGetApiResponses,
  SalesItemOfferListApiData,
  SalesItemOfferListApiResponses,
  SalesItemOfferPatchApiData,
  SalesItemOfferPatchApiResponses,
  SalesItemPatchApiData,
  SalesItemPatchApiResponses,
  SalesItemTagCreateApiData,
  SalesItemTagCreateApiResponses,
  SalesItemTagDeleteApiData,
  SalesItemTagDeleteApiResponses,
  SalesItemTagListApiData,
  SalesItemTagListApiResponses,
  SalesItemTagPatchApiData,
  SalesItemTagPatchApiResponses,
  SalesItemUnavailableForNewBookingApiData,
  SalesItemUnavailableForNewBookingApiResponses,
  SalesItemWheelsPickupOptionListApiData,
  SalesItemWheelsPickupOptionListApiResponses,
  ServiceCategoryCreateApiData,
  ServiceCategoryCreateApiResponses,
  ServiceCategoryGetApiData,
  ServiceCategoryGetApiResponses,
  ServiceCategoryListApiData,
  ServiceCategoryListApiResponses,
  ServiceCategoryPatchApiData,
  ServiceCategoryPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

// Sales items

export const getSalesItemsUrls = {
  getSalesItemMinimalList: dataEndpoint<SalesItemMinimalListApiData, SalesItemMinimalListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-items/minimal/', queryParams)
  }),
  getPaginatedSalesItems: dataEndpoint<SalesItemListApiData, SalesItemListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-items/', queryParams)
  }),
  getPaginatedServiceDepartmentSalesItems: dataEndpoint<SalesItemOfferListApiData, SalesItemOfferListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-item-offers/', queryParams)
  }),
  getSalesItem: dataEndpoint<SalesItemGetApiData, SalesItemGetApiResponses>({
    getUrl: ({ salesItemId, ...queryParams }) => apiUrl(`sales-items/${salesItemId}/`, queryParams)
  }),
  getPaginatedSalesItemHourlyBonusServices: dataEndpoint<
    SalesItemHourlyBonusServiceListApiData,
    SalesItemHourlyBonusServiceListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-items/hourly-bonus-services/', queryParams)
  }),
  patchSalesItemHourlyBonusServices: responseEndpoint<
    SalesItemHourlyBonusServicePatchApiData,
    SalesItemHourlyBonusServicePatchApiResponses
  >({
    getUrl: () => apiUrl('sales-items/hourly-bonus-services/'),
    getBody: (data) => data
  }),
  patchSalesItem: responseEndpoint<SalesItemPatchApiData, SalesItemPatchApiResponses>({
    getUrl: ({ salesItemId }) => apiUrl(`sales-items/${salesItemId}/`),
    getBody: ({ salesItemId: _, ...body }) => body
  }),
  getServiceCategoryList: dataEndpoint<ServiceCategoryListApiData, ServiceCategoryListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-categories/', queryParams)
  }),
  getSalesItemBookingCategories: dataEndpoint<
    SalesItemBookingCategoryListApiData,
    SalesItemBookingCategoryListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-item-booking-categories/', queryParams)
  }),
  getPaginatedServiceCategories: dataEndpoint<ServiceCategoryListApiData, ServiceCategoryListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-categories/', queryParams)
  }),
  getServiceCategory: dataEndpoint<ServiceCategoryGetApiData, ServiceCategoryGetApiResponses>({
    getUrl: ({ serviceCategoryId }) => apiUrl(`service-categories/${serviceCategoryId}/`)
  }),
  postServiceCategory: responseEndpoint<ServiceCategoryCreateApiData, ServiceCategoryCreateApiResponses>({
    getUrl: () => apiUrl('service-categories/'),
    getBody: (data) => data
  }),
  patchServiceCategory: responseEndpoint<ServiceCategoryPatchApiData, ServiceCategoryPatchApiResponses>({
    getUrl: ({ serviceCategoryId }) => apiUrl(`service-categories/${serviceCategoryId}/`),
    getBody: ({ serviceCategoryId: _, ...body }) => body
  }),
  getUnavailableSalesItemsWithPost: responseEndpoint<
    SalesItemUnavailableForNewBookingApiData,
    SalesItemUnavailableForNewBookingApiResponses
  >({
    getUrl: () => apiUrl('sales-items/unavailable-for-new-booking/'),
    getBody: (body) => body
  }),
  postFetchAddons: responseEndpoint<
    SalesItemListAddonsForNewBookingApiData,
    SalesItemListAddonsForNewBookingApiResponses
  >({
    getUrl: () => apiUrl('sales-items/addons-for-new-booking/'),
    getBody: (body) => body
  }),
  getInitialAvailableSalesItems: responseEndpoint<
    SalesItemListInitialAvailableForBookingApiData,
    SalesItemListInitialAvailableForBookingApiResponses
  >({
    getUrl: () => apiUrl('sales-items/initial-available-for-booking/'),
    getBody: (body) => body
  }),
  getSalesItemsDeliveryCheck: dataEndpoint<SalesItemDeliveryCheckApiData, SalesItemDeliveryCheckApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-items/delivery-check/', queryParams)
  }),
  getTireHotelPickupSalesItemsOptions: dataEndpoint<
    SalesItemWheelsPickupOptionListApiData,
    SalesItemWheelsPickupOptionListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-items/wheels-pickup-options/', queryParams)
  }),
  getBookingCategoriesForNewBooking: dataEndpoint<
    SalesItemBookingCategoryForNewBookingListApiData,
    SalesItemBookingCategoryForNewBookingListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-item-booking-categories/for-new-booking/', queryParams)
  }),
  getPaginatedSalesItemOffers: dataEndpoint<SalesItemOfferListApiData, SalesItemOfferListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-item-offers/', queryParams)
  }),
  getSalesItemOffer: dataEndpoint<SalesItemOfferGetApiData, SalesItemOfferGetApiResponses>({
    getUrl: ({ salesItemOfferId }) => apiUrl(`sales-item-offers/${salesItemOfferId}/`)
  }),
  patchSalesItemOffer: responseEndpoint<SalesItemOfferPatchApiData, SalesItemOfferPatchApiResponses>({
    getUrl: ({ salesItemOfferId }) => apiUrl(`sales-item-offers/${salesItemOfferId}/`),
    getBody: (data) => data
  }),
  patchBatchSalesItemOffers: responseEndpoint<SalesItemOfferBatchPatchApiData, SalesItemOfferBatchPatchApiResponses>({
    getUrl: () => apiUrl('sales-item-offers/batch/'),
    getBody: (data) => data
  }),
  getPaginatedSalesItemTags: dataEndpoint<SalesItemTagListApiData, SalesItemTagListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-items/tags/', queryParams)
  }),
  postCreateSalesItemTag: responseEndpoint<SalesItemTagCreateApiData, SalesItemTagCreateApiResponses>({
    getUrl: () => apiUrl('sales-items/tags/'),
    getBody: (data) => data
  }),
  patchSalesItemTag: responseEndpoint<SalesItemTagPatchApiData, SalesItemTagPatchApiResponses>({
    getUrl: ({ salesItemTagId }) => apiUrl(`sales-items/tags/${salesItemTagId}/`),
    getBody: ({ salesItemTagId: _, ...body }) => body
  }),
  deleteSalesItemTag: dataEndpoint<SalesItemTagDeleteApiData, SalesItemTagDeleteApiResponses>({
    getUrl: ({ salesItemTagId }) => apiUrl(`sales-items/tags/${salesItemTagId}/`)
  }),
  patchBulkSalesItems: responseEndpoint<SalesItemBulkPatchApiData, SalesItemBulkPatchApiResponses>({
    getUrl: () => apiUrl('sales-items/'),
    getBody: (data) => data
  }),
  postCreateSalesItem: responseEndpoint<SalesItemCreateApiData, SalesItemCreateApiResponses>({
    getUrl: () => apiUrl('sales-items/'),
    getBody: (data) => data
  }),
  deleteSalesItem: dataEndpoint<SalesItemDeleteApiData, SalesItemDeleteApiResponses>({
    getUrl: ({ salesItemId }) => apiUrl(`sales-items/${salesItemId}/`)
  }),
  getPaginatedCatalogEntries: dataEndpoint<SalesItemCatalogEntryListApiData, SalesItemCatalogEntryListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-item-catalog/', queryParams)
  }),
  getCatalogEntry: dataEndpoint<SalesItemCatalogEntryGetApiData, SalesItemCatalogEntryGetApiResponses>({
    getUrl: ({ catalogEntryId }) => apiUrl(`sales-item-catalog/${catalogEntryId}/`)
  }),
  postCatalogEntry: responseEndpoint<SalesItemCatalogEntryCreateApiData, SalesItemCatalogEntryCreateApiResponses>({
    getUrl: () => apiUrl('sales-item-catalog/'),
    getBody: (data) => data
  }),
  patchCatalogEntry: responseEndpoint<SalesItemCatalogEntryPatchApiData, SalesItemCatalogEntryPatchApiResponses>({
    getUrl: ({ catalogEntryId }) => apiUrl(`sales-item-catalog/${catalogEntryId}/`),
    getBody: ({ catalogEntryId: _, ...body }) => body
  }),
  deleteCatalogEntry: responseEndpoint<SalesItemCatalogEntryDeleteApiData, SalesItemCatalogEntryDeleteApiResponses>({
    getUrl: ({ catalogEntryId }) => apiUrl(`sales-item-catalog/${catalogEntryId}/`)
  }),
  postAdoptCatalogEntry: responseEndpoint<SalesItemCatalogEntryAdoptApiData, SalesItemCatalogEntryAdoptApiResponses>({
    getUrl: ({ catalogEntryId }) => apiUrl(`sales-item-catalog/${catalogEntryId}/adopt/`),
    getBody: ({ catalogEntryId: _, ...rest }) => rest
  }),
  getPaginatedCatalogAdoptions: dataEndpoint<
    SalesItemCatalogAdoptionListApiData,
    SalesItemCatalogAdoptionListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-item-catalog/adoptions/', queryParams)
  }),
  getPaginatedSalesItemCargoDemands: dataEndpoint<
    SalesItemCargoDemandListApiData,
    SalesItemCargoDemandListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-item-cargo-demands/', queryParams)
  }),
  getSalesItemCargoDemandTotalList: dataEndpoint<
    SalesItemCargoDemandTotalListApiData,
    SalesItemCargoDemandTotalListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-item-cargo-demands/total/', queryParams)
  }),
  postSalesItemCargoDemand: responseEndpoint<SalesItemCargoDemandCreateApiData, SalesItemCargoDemandCreateApiResponses>(
    {
      getUrl: () => apiUrl('sales-item-cargo-demands/'),
      getBody: (data) => data
    }
  ),
  patchSalesItemCargoDemand: responseEndpoint<SalesItemCargoDemandPatchApiData, SalesItemCargoDemandPatchApiResponses>({
    getUrl: ({ salesItemCargoDemandId }) => apiUrl(`sales-item-cargo-demands/${salesItemCargoDemandId}/`),
    getBody: ({ salesItemCargoDemandId: _, ...body }) => body
  }),
  deleteSalesItemCargoDemand: dataEndpoint<SalesItemCargoDemandDeleteApiData, SalesItemCargoDemandDeleteApiResponses>({
    getUrl: ({ salesItemCargoDemandId }) => apiUrl(`sales-item-cargo-demands/${salesItemCargoDemandId}/`)
  }),
  getPaginatedSalesItemAddons: dataEndpoint<SalesItemAddonListApiData, SalesItemAddonListApiResponses>({
    getUrl: (queryParams) => apiUrl('sales-item-addons/', queryParams)
  }),
  postSalesItemAddon: responseEndpoint<SalesItemAddonCreateApiData, SalesItemAddonCreateApiResponses>({
    getUrl: () => apiUrl('sales-item-addons/'),
    getBody: (data) => data
  }),
  patchSalesItemAddon: responseEndpoint<SalesItemAddonPatchApiData, SalesItemAddonPatchApiResponses>({
    getUrl: ({ salesItemAddonId }) => apiUrl(`sales-item-addons/${salesItemAddonId}/`),
    getBody: ({ salesItemAddonId: _, ...body }) => body
  }),
  deleteSalesItemAddon: dataEndpoint<SalesItemAddonDeleteApiData, SalesItemAddonDeleteApiResponses>({
    getUrl: ({ salesItemAddonId }) => apiUrl(`sales-item-addons/${salesItemAddonId}/`)
  })
};
